export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  Assignment = 'Assignment',
  Website = 'Website',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
